module.exports = __webpack_public_path__ + "static/SlappysRoom-92f323a61a130a668f9382a5a68706c2.jpg";